import { getGoogleMapLanguageFromLocale } from '@repo/utils'
import { useState } from 'react'
import usePlacesService from 'react-google-autocomplete/lib/usePlacesAutocompleteService'

import { GEOGRAPHICAL_SEARCH_BOUNDS } from './GEOGRAPHICAL_SEARCH_BOUNDS'
import { useLocale } from '../../../hooks/use-locale'

type UseLocationPickerProps = {
  locationTypes: string[]
}

export const useLocationPicker = ({
  locationTypes,
}: UseLocationPickerProps) => {
  const { locale } = useLocale()

  const [isEditing, setEditing] = useState(false)
  const [searchQuery, setSearchQuery] = useState<string | undefined>(undefined)
  const [isLocationSelected, setIsLocationSelected] = useState(false)

  const { placePredictions, getPlacePredictions, isPlacePredictionsLoading } =
    usePlacesService({
      apiKey: process.env.NEXT_PUBLIC_GOOGLE_KEY,
    })

  const onSearchQuery = (value?: string) => {
    setSearchQuery(value)
  }
  const searchQueryIsEmpty =
    searchQuery?.trim()?.length === 0 || searchQuery === undefined

  const onInputChange = (e: { target: { value: string } }) => {
    onSearchQuery(e.target.value)
    getPlacePredictions({
      input: e.target.value,
      types: locationTypes,
      language: getGoogleMapLanguageFromLocale(locale),
      locationRestriction: GEOGRAPHICAL_SEARCH_BOUNDS,
    })
  }

  const onEditing = (value: boolean) => {
    setEditing(value)
  }

  const onLocationSelected = (value: boolean) => {
    setIsLocationSelected(value)
  }

  return {
    isEditing,
    onEditing,
    searchQuery,
    onSearchQuery,
    searchQueryIsEmpty,
    placePredictions,
    isPlacePredictionsLoading,
    onInputChange,
    isLocationSelected,
    onLocationSelected,
  }
}
